import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { NumberField } from "../../../../../Utils/renderField/fieldsHookForms";
import Modal from "react-responsive-modal";
import { AlmacenesInventarioApi } from "../api/AlmacenesInventarioApi";
import { useForm } from "react-hook-form";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

export const FormReajuste = (props) => {
    const { almacenInvReajuste, onClose, onRefresh } = props;

    // formulario
    const {
        control,
        formState: { errors },
        getValues: formGetValues,
        setValue: formSetValue,
        watch,
        trigger: validateForm,
        clearErrors: clearSubmitErrors,
    } = useForm();

    const [fueReajustado, setFueReajustado] = React.useState(false);

    const { guardarReajusteInventario, eliminarReajusteInventario, cargando } =
        AlmacenesInventarioApi();

    const GuardarReajuste = async () => {
        try {
            const isValid = await validateForm();
            if (!isValid) {
                return;
            }

            const data = {
                ...formGetValues(),
            };
            await guardarReajusteInventario(
                almacenInvReajuste.inventario_almacen_id,
                data,
            );

            NotificationManager.success(
                "Reajuste guardado con éxito",
                "Éxito",
                3000,
            );

            onClose();
            onRefresh();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al guardar reajuste de inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EliminarReajuste = async () => {
        try {
            await eliminarReajusteInventario(
                almacenInvReajuste.inventario_almacen_id,
            );

            NotificationManager.success(
                "Reajuste eliminado con éxito",
                "Éxito",
                3000,
            );

            onClose();
            onRefresh();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar reajuste de inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        if (almacenInvReajuste && almacenInvReajuste.anterior) {
            const _fueReajustado =
                almacenInvReajuste.anterior.inv_inicial_reajustado;
            if (_fueReajustado) {
                formSetValue(
                    "kg_secos_lab",
                    almacenInvReajuste.anterior.kg_secos_lab,
                );
                formSetValue(
                    "kg_secos_liq",
                    almacenInvReajuste.anterior.kg_secos_liq,
                );
                setFueReajustado(
                    true
                );
            } else {
                formSetValue("kg_secos_lab", null);
                formSetValue("kg_secos_liq", null);
                setFueReajustado(false);
            }
        } else {
            formSetValue("kg_secos_lab", null);
            formSetValue("kg_secos_liq", null);
            setFueReajustado(false);
        }
    }, [almacenInvReajuste, formSetValue]);

    return (
        <Modal
            open={almacenInvReajuste !== null}
            onClose={onClose}
            closeOnOverlayClick={!cargando}
            focusTrapped={false}
        >
            <LoadMask loading={cargando} blur>
                <h2 className="text-center">Ingresar nuevo reajuste</h2>

                {/* Pesos */}
                <div className="formulario-fields-row">
                    <div className="formulario-field">
                        <label htmlFor="kg_secos_lab" className="m-0">
                            Inventario inicial laboratorio
                        </label>

                        <NumberField
                            control={control}
                            name="kg_secos_lab"
                            errors={errors}
                            allowNegative={false}
                            onEnterAction={() => trigger("kg_secos_lab")}
                            suffix=" Kg"
                            placeholder="0 Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                            }}
                            decimalScale={3}
                        />
                    </div>

                    <div className="formulario-field">
                        <label htmlFor="kg_secos_liq" className="m-0">
                            Inventario inicial liquidación
                        </label>

                        <NumberField
                            control={control}
                            name="kg_secos_liq"
                            errors={errors}
                            allowNegative={false}
                            onEnterAction={() => trigger("kg_secos_liq")}
                            suffix=" Kg"
                            placeholder="0 Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                            }}
                            decimalScale={3}
                        />
                    </div>
                </div>

                <div
                    className="d-flex flex-wrap justify-content-center mt-4 mb-2"
                    style={{ gap: "1rem" }}
                >
                    <button
                        className="btn btn-outline-dark"
                        onClick={() => {onClose(); clearSubmitErrors();}}
                        disabled={cargando}
                    >
                        Cancelar
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={GuardarReajuste}
                    >
                        Guardar cambios
                    </button>
                    {fueReajustado && (
                        <button
                            className="btn btn-secondary"
                            onClick={EliminarReajuste}
                        >
                            Eliminar reajuste
                        </button>
                    )}
                </div>
            </LoadMask>
        </Modal>
    );
};
